import React, { useState, useEffect } from "react";
import Map from "../Client/Map";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  setTheAttendanceLocationCreateAction,
  setTheAttendanceLocationRetrieveMetyhodAction,
  setTheAttendanceLocationEditionsAction,
} from "../../../Redux/Slice";
const AttendanceLocationCrud = (props) => {
  const { setShow, show, currentPage, EditID, search } = props;
  const state = useSelector((state) => state);
  const [mapCenter, setMapCenter] = useState({
    lat: 13.0843007,
    lng: 80.2704622,
    // lat: 13.0843007,
    // lng: 80.2704622,
    
  });
  const [data, setdata] = useState({
    place_name: "",
  });
  const [placeErr, setplaceErr] = useState("");
  const LocationChanges = (event) => {
    setMapCenter({
      ...mapCenter,
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });
  };
  const dispatch = useDispatch();
  const HandleChanges = (e) => {
    const { name, value } = e.target;

    setdata({
      ...data,
      [name]: value,
    });
  };
  const SearchedLoc = (map) => {
    setMapCenter({
      ...mapCenter,
      lat: map.lat,
      lng: map.lng,
    });
  };
  useEffect(() => {
    if (EditID != undefined && EditID != "") {
      const payload = {
        EditID: EditID,
      };
      dispatch(setTheAttendanceLocationRetrieveMetyhodAction(payload));
    }
  }, []);

  useEffect(() => {
    if (
      EditID != undefined &&
      EditID != "" &&
      state.AttendanceLocationSliceRetrieveMethosCall
        .AttendanceLocationRetrievemethodData.id
    ) {
      setdata({
        ...data,
        place_name:
          state.AttendanceLocationSliceRetrieveMethosCall
            .AttendanceLocationRetrievemethodData.place_name,
      });

      setMapCenter({
        ...mapCenter,
        lat: Number(
          state.AttendanceLocationSliceRetrieveMethosCall
            .AttendanceLocationRetrievemethodData.latitude
        ),
        lng: Number(
          state.AttendanceLocationSliceRetrieveMethosCall
            .AttendanceLocationRetrievemethodData.longitude
        ),
      });
    }
  }, [
    state.AttendanceLocationSliceRetrieveMethosCall
      .AttendanceLocationRetrievemethodData,
  ]);

  const HandleSubmit = (e) => {
    var a = 0;
    if (data.place_name == "") {
      setplaceErr("*Place is required");
      a = 1;
    }
    if (a == 0) {
      if (EditID != undefined && EditID != "") {
        const payload = {
          data: {
            place_name: data.place_name,
            latitude: mapCenter.lat,
            longitude: mapCenter.lng,
          },
          EditID: EditID,
          GetList: {
            search: search,
            page_size: 20,
            page: currentPage,
          },
        };
        dispatch(
          setTheAttendanceLocationEditionsAction(payload, setShow(false))
        );
      } else {
        const payload = {
          data: {
            place_name: data.place_name,
            latitude: mapCenter.lat,
            longitude: mapCenter.lng,
          },
          GetList: {
            search: search,
            page_size: 20,
            page: currentPage,
          },
        };
        dispatch(setTheAttendanceLocationCreateAction(payload, setShow(false)));
      }
    }
  };
  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{ width: "77%" }}>
            <div className="asds">
              <div class="ModalHeader">
                <span className="UserCreate"> Attendance Location </span>

                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>
              <div className="row InnerBodyMapCenter">
                <div className="col-6 InnerRowsIntheCol6">
                  <div className="row">
                    <div className="row">
                      <div className="col-sm">
                        <label for="validationCustom01" class="form-label">
                          Place
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          autocomplete="off"
                          name="place_name"
                          value={data.place_name}
                          onChange={(e) => {
                            HandleChanges(e);
                            setplaceErr("");
                          }}
                        />
                        <p className="ErrorMsg"> {placeErr} </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 ">
                        <label
                          for="validationCustom01"
                          class="form-label-Header"
                        >
                          Location<span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="col mt-3">
                        <label class="form-label">Latitude</label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          autocomplete="off"
                          name="name"
                          value={mapCenter.lat}

                          // readOnly
                          readOnly={
                            state.ClientBranchIDs.SUBROLE == 3 ? false :
                             true

                          }
                           disabled={
                            state.ClientBranchIDs.SUBROLE == 3 ? false :
                            true
                           }
                           onChange={(e)=>{
                            setMapCenter({
                              ...mapCenter,
                              lat:Number(e.target.value)
                            })
                           }}        
                                           // readOnly
                        />
                      </div>
                      <div className="col mt-3">
                        <label class="form-label">Longitude</label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          autocomplete="off"
                          name="name"
                          // readOnly               
                          value={mapCenter.lng}
                          readOnly={
                            state.ClientBranchIDs.SUBROLE == 3 ? false :
                             true}
                           disabled={
                            state.ClientBranchIDs.SUBROLE == 3 ? false :
                            true
                           }
                           onChange={(e)=>{
                            setMapCenter({
                              ...mapCenter,
                              lng:Number(e.target.value)
                            })
                           }}

                          // readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 Map">
                  <label class="form-label">Map</label>
                  <Map
                    mapCenter={mapCenter}
                    setMapCenter={setMapCenter}
                    ChangeLocation={LocationChanges}
                    SearchedLocaitons={SearchedLoc}
                  />
                </div>
              </div>
              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <button class="btn CancelBtn" onClick={(e) => setShow(false)}>
                  Cancel
                </button>
                <button
                  class="btn  SaveBtn CancelBtn"
                  type="submit"
                  onClick={(e) => {
                    HandleSubmit(e);
                    // HandleEdits(e);
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceLocationCrud;
